import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import AdminSidebar from "../components/Sidebar/AdminSidebar";
import { getLocalStorage } from "../utils";
import { LOCAL_STORAGE_KEYS, ROLES } from "../constants";
import { AppDispatch } from "../redux/store";
import { useDispatch, useSelector } from "react-redux";
import {
  getUserDetails,
  getPermission,
} from "../redux/actions/admin/authAction";
import AdminNavbar from "../components/Navbar/AdminNavbar";
import { RootState } from "../redux/reducers/allReducers";

let count = 0;
const AdminLayout = () => {
  const dispatch: AppDispatch = useDispatch();

  const { userInfo }: any = useSelector((state: RootState) => state.user);
  const [sidebarOpen, setSidebarOpen] = useState<boolean>(false);
  const isAuthenticated = getLocalStorage(LOCAL_STORAGE_KEYS.ACCESS_TOKEN);
  const userRole = getLocalStorage(LOCAL_STORAGE_KEYS.USER_ROLE);

  useEffect(() => {
    if (
      isAuthenticated &&
      (userRole === ROLES.ADMIN ||
        userRole === ROLES.STAFF ||
        userRole === ROLES.AGENT ||
        userRole === ROLES.BUILDER ||
        userRole === ROLES.SALES) &&
      !count
    ) {
      count++;
      dispatch(getUserDetails());
    }
  }, []);

  useEffect(() => {
    if (userInfo?._id && userRole === ROLES.STAFF) {
      dispatch(getPermission());
    }
  }, [userInfo?._id]);

  return (
    <div className="admin-layout min-h-screen">
      <div className="flex items-start h-screen">
        <AdminSidebar
          sidebarOpen={sidebarOpen}
          closeSidebar={() => setSidebarOpen(false)}
        />
        <div className={`w-full md:w-[calc(100vw-18rem)] ml-0 md:ml-[18rem]`}>
          <AdminNavbar openSidebar={() => setSidebarOpen(true)} />
          <section className={`px-3 py-6 z-40`}>
            <Outlet />
          </section>
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;
